/**
 * Created by Administrador on 11/29/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('Auth', OauthService);

    OauthService.$inject = ['$rootScope', '$state', '$sessionStorage','CONFIG', '$http', '$cookies', '$httpParamSerializer', '$q', 'messageService', 'User', '$location', 'Principal', 'AuthServerProvider'];

    function OauthService($rootScope, $state, $sessionStorage, CONFIG, $http, $cookies, $httpParamSerializer, $q, messageService, User, $location, Principal, AuthServerProvider){
        var urlBaseOauth = CONFIG.API_URL + '/uaa';
        var currentUser = {};
        var userRoles = CONFIG.USER_ROLES || [];
        var auth = {
            login: login,
            loginCurrent: loginCurrent,
            logout: logout,
            destroy: destroy,
            isLoggedIn: isLoggedIn,
            isAuthorized: isAuthorized,
            setAccessToken: setAccessToken,
            authorize: authorize,
            getPreviousState: getPreviousState,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState/*,
            hasRole: hasRole,
            getCurrentUser: getCurrentUser*/
        }

        // When the page load again
        if ($cookies.get('access_token') && $location.path() !== '/logout') {
            //currentUser = User.get();
            authorize(true);
        }

        return auth;

        function logout(cb){
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function destroy() {
            $cookies.remove("access_token");
            $cookies.remove("refresh");
            $cookies.remove("expires_in");
            currentUser = {};
            delete $http.defaults.headers.common["Authorization"];
            delete $http.defaults.headers.common["access"];
            delete $http.defaults.headers.common["refresh"];
        }

        function login(data, callback) {
            data = angular.extend({
                client_id: "client",
                grant_type: "password"
            }, data);
            data = queryString.stringify(data);


            var encoded = btoa(CONFIG.CLIENT + ':' + CONFIG.SECRET);
            var options = angular.extend({
                headers: {
                    Authorization: "Basic " + encoded,
                    "Content-Type": "application/x-www-form-urlencoded",
                    AuthorizationBasic: encoded
                }
            }, options);

            return $http.post("" + urlBaseOauth + '/login', data, options).then(function(response) {
                auth.setAccessToken(response.data);
                currentUser = User.get();
                return currentUser.$promise;
            });
        }

        function loginCurrent (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (response) {
                AuthServerProvider.setAccessToken(response.data);
                Principal.identity(true).then(function(account) {
                    deferred.resolve(response);
                });
                return cb();
            }

            return deferred.promise;
        }

        function isLoggedIn () {
            return !!currentUser.hasOwnProperty('roles');
        }

        function isAuthorized(authorizedRoles) {
            if (!angular.isArray(authorizedRoles)) {
                authorizedRoles = [authorizedRoles];
            }
            var roles = currentUser.roles;
            var res = -1;

            //if(roles !== undefined) {
                for(var i = 0; i < roles.length; i++){
                    res = authorizedRoles.indexOf(roles[i]);
                    if(res !== -1){
                        break;
                    }
                }
            //}

            return (auth.isLoggedIn() && res !== -1);
        }

        function setAccessToken(data) {
            var expireDate = new Date (new Date().getTime() + (1000 * data.expires_in));
            $cookies.put("access_token", data.access_token, {'expires': expireDate});
            $cookies.put("refresh", data.refresh_token, {'expires': expireDate});
            $cookies.put("expires_in", expireDate);
        }

        function hasRole(){
            var hasRole = function(r, h) {
                return userRoles.indexOf(r) >= userRoles.indexOf(h);
            };

            if (arguments.length < 2) {
                return hasRole(currentUser.role, role);
            }

            return Auth.getCurrentUser(null)
                    .then(function(user){
                        var has = user.hasOwnProperty('role') ? hasRole(user.role, role) : false;
                        safeCb(callback)(has);
                        return has;
                    });
        }

        function getCurrentUser(callback) {
            if (arguments.length === 0) {
                return currentUser;
            }

            var value = currentUser.hasOwnProperty('$promise') ? currentUser.$promise : currentUser;
            return $q.when(value).then(function(user) {
                    safeCb(callback)(user);
                    return user;
                    }, function() {
                        safeCb(callback)({});
                    return {};
                 });
        }

        function authorize(force) {
            var oauthReturn = Principal.identity(force).then(oauthThen);

            return oauthReturn;

            function oauthThen() {
                var isAuthenticated = Principal.isAuthenticated();
                if (isAuthenticated && $rootScope.toState.parent === 'app' && $rootScope.toState.name === 'home') {
                    $state.go('dashboard');
                }

                if (isAuthenticated && $rootScope.toState.parent === 'app' && ($rootScope.toState.name === 'home')) {
                    $state.go('dashboard');
                }

                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    // $state.go('home');
                    $state.go('home');
                }

                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities))
                {
                    if (isAuthenticated) {
                        $state.go('accessdenied');
                    } else {
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        $state.go('accessdenied').then(function() {
                            $state.go('home');
                        });
                    }
                }
            }
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
